import { const_routes } from '../helpers/const_routes';
import { fetchToken } from '../helpers/fetch';
import { debugLogActions } from '../helpers/debugHelper';
import Swal from 'sweetalert2';
import { t } from 'i18next';

export const fetchFlowHistoryByRecord = async (catalogmoduleId, referenceId, subjectKind) => {
  const query = subjectKind ? `?subject_kind=${encodeURIComponent(subjectKind)}` : "";
  const resp = await fetchToken(
    `${const_routes.SCHEMA}`,
    `${const_routes.VERSIONV1}`,
    `${const_routes.ROUTE_FLOW_HISTORY}`,
    `getByRecord/${catalogmoduleId}/${referenceId}${query}`
  );

  const body = await resp.json();
  debugLogActions(':: flowHistoryActions.fetchFlowHistoryByRecord', { body });

  if (!body.ok) {
    throw body;
  }

  return body.flowHistories || [];
};

export const fetchFlowHistoriesByRecords = async (catalogmoduleId, referenceIds = [], subjectKind) => {
  const ids = (referenceIds || [])
    .map((id) => Number(id))
    .filter((id) => Number.isFinite(id) && id > 0);
  if (!ids.length) {
    return [];
  }

  const resp = await fetchToken(
    `${const_routes.SCHEMA}`,
    `${const_routes.VERSIONV1}`,
    `${const_routes.ROUTE_FLOW_HISTORY}`,
    `get?catalogmodule_id=${catalogmoduleId}&reference_ids=${ids.join(',')}${subjectKind ? `&subject_kind=${encodeURIComponent(subjectKind)}` : ""}`
  );

  const body = await resp.json();
  debugLogActions(':: flowHistoryActions.fetchFlowHistoriesByRecords', { count: body.flowHistories?.length });

  if (!body.ok) {
    throw body;
  }

  return body.flowHistories || [];
};

export const startDownloadFlowHistoryExcel = async (catalogmoduleId, referenceId, recordCode = '') => {
  const query = recordCode ? `?code=${encodeURIComponent(recordCode)}` : '';
  const resp = await fetchToken(
    `${const_routes.SCHEMA}`,
    `${const_routes.VERSIONV1}`,
    `${const_routes.ROUTE_FLOW_HISTORY}`,
    `export-excel/${catalogmoduleId}/${referenceId}${query}`
  );

  const contentType = (resp.headers.get('content-type') || '').toLowerCase();
  if (!resp.ok || contentType.includes('application/json')) {
    const body = await resp.json().catch(() => ({}));
    debugLogActions(':: flowHistoryActions.startDownloadFlowHistoryExcel', { body });
    Swal.fire(
      t('titles.error'),
      body.msg || t('general.flow-engine.history.export-error', 'No se pudo exportar el historial.'),
      'error'
    );
    return { ok: false, msg: body.msg || 'download-error' };
  }

  const blob = await resp.blob();
  const disposition = resp.headers.get('content-disposition') || '';
  const match = disposition.match(/filename="?([^"]+)"?/i);
  const filename = (match && match[1]) || `historial_flujo_${referenceId}.xlsx`;
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
  return { ok: true, filename };
};
